import { PermissionCode } from "@/constants/permissions";
import { AppRoutes } from "@/constants/routes";
import { Flex, Link, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { Permiso } from "@/pages/role-asignation/schema/role-assignation.schema";

interface Props {
  permissions: Permiso[];
}

export const AccountsView = ({ permissions }: Props) => {
  const navigate = useNavigate();

  const hasAccess = (codigo: string) =>
    permissions?.some((p) => p.codigo === codigo && p.tipoPermiso === "R");

  const canUseAccounts =
    hasAccess(PermissionCode.ACCOUNTS);

  const canUseCBU =
    hasAccess(PermissionCode.CBU);

  return (
    <Flex flexDir="column" paddingX={2} paddingY={1} gap="10px">
      {canUseAccounts && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.ACCOUNTS)}>
          <Text
            fontWeight={500}
            fontSize={{ base: "12px", md: "12px", "2xl": "16px" }}
          >
            Cuentas
          </Text>
        </Link>
      )}
      {canUseCBU && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.CBU)}>
          <Text
            fontWeight={500}
            fontSize={{ base: "12px", md: "12px", "2xl": "16px" }}
          >
            CBU
          </Text>
        </Link>
      )}
    </Flex>
  );
};
